import React, { useEffect } from 'react';

export default function Toast({ message, type = 'success', onClose }) {
  useEffect(() => {
    const timer = setTimeout(onClose, 5000);
    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div
      className="fixed bottom-6 right-6 z-[300] flex items-start gap-3 px-5 py-4 rounded-xl shadow-xl max-w-sm animate-fade-in"
      style={{
        background: type === 'success' ? '#f0fdf4' : '#fef2f2',
        border: `1px solid ${type === 'success' ? 'rgba(5,150,105,0.2)' : 'rgba(220,38,38,0.2)'}`,
      }}
    >
      <div
        className="w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5"
        style={{ background: type === 'success' ? 'rgba(5,150,105,0.15)' : 'rgba(220,38,38,0.15)' }}
      >
        {type === 'success' ? (
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" style={{ color: '#059669' }}>
            <path d="M20 6L9 17l-5-5"/>
          </svg>
        ) : (
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" style={{ color: '#dc2626' }}>
            <path d="M18 6L6 18M6 6l12 12"/>
          </svg>
        )}
      </div>
      <div className="flex-1">
        <p className="text-sm font-body" style={{ color: type === 'success' ? '#065f46' : '#991b1b' }}>{message}</p>
      </div>
      <button
        onClick={onClose}
        className="flex-shrink-0 text-gray-400 hover:text-gray-600 transition-colors"
        aria-label="Dismiss"
      >
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M18 6L6 18M6 6l12 12"/>
        </svg>
      </button>
    </div>
  );
}
